import React from 'react'
import createReactClass from 'create-react-class'
import RefreshTokenModalPanel from './modal-panels/refresh-token-modal-panel'

export default createReactClass({
  getInitialState () {
    return {
      showModal: false,
    }
  },
  onRefreshTokenClick () {
    this.setState({
      showModal: true,
    })
  },
  closeModal () {
    this.setState({
      showModal: false,
    })
  },
  renderModalPanel () {
    if (this.state.showModal) {
      return (
        <RefreshTokenModalPanel {...this.props} closeModal={this.closeModal}/>
      )
    }
    return false
  },
  render () {
    return (
      <li><a onClick={this.onRefreshTokenClick}>Refresh Token</a>{this.renderModalPanel()}</li>
    )
  },
  componentWillReceiveProps (nextProps) {
    if (nextProps.isTokenRefreshed) {
      this.closeModal()
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/refresh-token-panel.js